module.exports = __webpack_public_path__ + "img/red_014.6e7664e4.png";